import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Overlay from '../../Miscelania/Overlay';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import { Modal } from 'react-bootstrap';
import getLocale from '../../../i18n/getLocale';

class ScheduleInitialsSelectModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      modal: false,
      loaded: 0,
      staff_id: '',
      schedule_grade_id: '',
      date_start: '',
      date_finish: '',
      types_list: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);

    this.locale = getLocale();

    this.modalPropsOff = this.modalPropsOff.bind(this);
    this.add = this.add.bind(this);
  }
  // Handlers
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  //LM
  componentWillReceiveProps(newProps) {
    if (newProps.modal_props === true) {
      this.setState({ modal: true });
      if(typeof newProps.staff_id !== 'undefined') {
        this.setState({
          staff_id: newProps.staff_id,
          schedule_grade_id: newProps.schedule_grade_id,
          type: newProps.type,
          date_start: newProps.date_start,
          date_finish: newProps.date_finish,
          types_list: newProps.types_list,
        });
      }
    } else {
      this.setState({ modal: false });
    }
  }

  modalPropsOff () {
    this.props.modalPropsOff();
  }

  add(event) {
    event.preventDefault();
    var self = this;
    this.props.handleAlert('', '', 'open');
    var datasave = {
      staff_id: this.state.staff_id,
      schedule_grade_id: this.state.schedule_grade_id,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      schedule_initial: this.state.schedule_initial,
      type: this.state.type,
    };
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/adicionar/alternativo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ modal: false });
          self.modalPropsOff();
          self.props.updateData(responseJson);
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabChefesDeEquipamento.tituloSelecioneUmaSiglaParaPreencher}</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.modalPropsOff()}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.add}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabChefesDeEquipamento.formulario.Sigla}:</label>
                    <Select
                      className="form-field-name"
                      name="schedule_initial"
                      value={this.state.schedule_initial}
                      searchable={true}
                      placeholder={this.locale.GradesDeEscala.EditarGradeDeEscala.tabChefesDeEquipamento.formulario.placeholder.SelecionarSigla}
                      onChange={this.handleSelectChange.bind(this, 'schedule_initial')}
                      options={this.state.types_list}
                    />    
                  </div>
                </div>
              </div>  
              <div className="row">
                <div className="col-md-12">
                  <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvar} </button>
                </div>
              </div>
            </form>    
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.modalPropsOff()}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default ScheduleInitialsSelectModal;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleInitialsSelectModal.js